var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2018e4c3714da565ef046f08546d16432cc8d889"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["w2v-web-app@way2vat"]={id:"2018e4c3714da565ef046f08546d16432cc8d889"};
      